// store.js
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './authSlice';
import itemsReducer from './itemSlice';
import invoiceReducer from './invoiceSlice';
import indentReducer from './indentSlice';
import peindentReducer from './peindentSlice';
import peitemsReducer from './peitemsSlice';
import dashboardReducer from './dashboardSlice';
import { createLogger } from 'redux-logger';

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, authReducer);

const store = configureStore({
  reducer: {
    auth: persistedReducer,
    items: itemsReducer,
    invoice: invoiceReducer,
    indent: indentReducer,
    peindent: peindentReducer,
    peitem: peitemsReducer,
    dashboard: dashboardReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(createLogger())
});

export const persistor = persistStore(store);
export default store;